import type { StatusCategory } from "../api";
import type { BadgeVariant } from "../components/ui/Badge";

/**
 * Map status category to badge variant for consistent styling across components.
 */
export const statusCategoryToVariant: Record<StatusCategory, BadgeVariant> = {
  todo: "todo",
  in_progress: "inProgress",
  done: "done",
  cancelled: "cancelled",
};

/**
 * Map built-in item type names to badge variants. Types are project-defined,
 * so callers fall back to "task" for a name that is not listed here.
 */
export const itemTypeToVariant: Record<string, BadgeVariant> = {
  Epic: "epic",
  Story: "story",
  Task: "task",
  Bug: "bug",
};

/** Turn a snake_case enum value into a display label: "in_progress" → "In Progress". */
export function humanise(value: string): string {
  return value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
